module.exports = __webpack_public_path__ + "officialStatic/img/detail-diffict8.a1e3500.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-diffict8.png
// module id = aAdi
// module chunks = 0